import { AccessDeniedError, UnexpectedError } from "../../domain/errors";
import { UnauthorizedError } from "../../domain/errors/unauthorized-error";
import { NormalizedCargo } from "../../domain/models/cargo-model";
import {
  LoadCargosFilterOptions,
  LoadNormalizedCargos,
} from "../../domain/usecases/load-normalized-cargos";
import { HttpClient, HttpStatusCode } from "../protocols/http";

export class DbLoadNormalizedCargo implements LoadNormalizedCargos {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}
  async load(
    warehouseId: number,
    filter: LoadCargosFilterOptions
  ): Promise<NormalizedCargo[]> {
    const res = await this.httpClient.request({
      url: this.url,
      method: "get",
      params: { warehouseId, filterOptions: filter },
    });
    switch (res.statusCode) {
      case HttpStatusCode.ok:
        return res.body;
      case HttpStatusCode.forbidden:
        throw new AccessDeniedError();
      case HttpStatusCode.unauthorized:
        throw new UnauthorizedError();
      default:
        throw new UnexpectedError();
    }
  }
}
